import { render, staticRenderFns } from "./VerifyJobStatusChange.vue?vue&type=template&id=70a8ec8e&"
import script from "./VerifyJobStatusChange.vue?vue&type=script&lang=js&"
export * from "./VerifyJobStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports